const htmlBuilderStore = {
  namespaced: true,
  state () {
    return {
      themeControl: true,
      appearance: {
        theme: 'light',
        panels: {
          tools: {
            dock: 'right',
          },
        },
      },
    }
  },
  mutations: {
    changeAppearanceTheme (state, newAppearanceTheme) {
      state.appearance.theme = newAppearanceTheme
    },
    async toggleThemeControl (state) {
      state.themeControl = !state.themeControl
    }
  }
}

export default htmlBuilderStore